import { render, staticRenderFns } from "./ConfirmButton.vue?vue&type=template&id=89b63818&scoped=true"
import script from "./ConfirmButton.vue?vue&type=script&lang=js"
export * from "./ConfirmButton.vue?vue&type=script&lang=js"
import style0 from "./ConfirmButton.vue?vue&type=style&index=0&id=89b63818&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b63818",
  null
  
)

export default component.exports